/* eslint-disable vue/no-unused-vars */
<template>
  <div>
    <a-card style="margin-bottom:1rem" class="card">
      <div slot="title">
        <a-button
          type="primary"
          size="small"
          icon="left"
          shape="circle"
          class="back-button"
          style="margin-right:1rem"
          @click="backButton"
        />
        <span v-if="isAddSubscription" class="hover-title main-card-title"
          >NUEVA SUSCRIPCIÓN</span
        >
        <span v-else class="hover-title">
          <a-skeleton
            v-if="loading"
            :paragraph="{ rows: 0 }"
            active
          ></a-skeleton>
          <span v-else class="main-card-title">
            <a-icon type="tag" style="margin-right:5px"></a-icon
            >{{ subscription.name }}
            <span style="font-size:1rem">id: #{{ subscription.id }}</span>
          </span>
        </span>
        <!--<a-icon @click="backButton()" type="arrow-left">Volver </a-icon>-->
      </div>

      <a-form class="add-form" :form="form" @submit="handleSubmit" novalidate>
        <a-form-item has-feedback>
          <a-input
            name="name"
            ref="initial"
            placeholder="Título"
            v-decorator="[
              'name',
              {
                //getValueFromEvent: formatCardNumber,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese el título.'
                  }
                ]
              }
            ]"
          >
            <a-icon
              slot="prefix"
              type="font-size"
              style="color: rgba(0,0,0,.25);"
            />
          </a-input>
        </a-form-item>

        <a-form-item
          has-feedback
          :validate-status="amount.validateStatus"
          :help="amount.errorMsg"
        >
          <a-input-number
            ref="amount"
            name="amount"
            pattern="[0-9]*"
            placeholder="Precio"
            :formatter="
              value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="value => value.replace(/\$\s?|(,*)/g, '')"
            class="add-form"
            v-decorator="['amount', {}]"
          >
          </a-input-number>
        </a-form-item>

        <a-form-item has-feedback>
          <a-select
            placeholder="Seleccionar el producto"
            this.loadingProducts
            @dropdownVisibleChange="loadProducts()"
            @change="handleProductChange"
            :notFoundContent="loadingProducts ? undefined : null"
            v-decorator="[
              'productId',
              {
                //getValueFromEvent: formatCardNumber,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese el producto.'
                  }
                ]
              }
            ]"
          >
            <a-spin
              v-if="loadingProducts"
              slot="notFoundContent"
              size="small"
            />
            <a-select-option v-for="item in this.products" :key="item.id"
              >{{ item.name }}&nbsp;<span style="color:#ccc; font-size:10px"
                >-&nbsp;{{ item.ERPCode }}</span
              ></a-select-option
            >
          </a-select>
          <a-tooltip
            title="El producto determina el tipo de curso/actividad. Ej: Happiness Program"
            placement="right"
            ><a-icon
              type="question-circle-o"
              class="tooltip-icon tooltip-top"
            />
          </a-tooltip>
        </a-form-item>

        <a-form-item has-feedback v-if="displayCascader">
          <a-cascader
            :options="cascaderOptions"
            :loadData="loadCascaderData"
            :disabled="cascaderDisabled"
            placeholder="Seleccionar el centro de costos"
            changeOnSelect
            v-decorator="[
              'costCenter',
              {
                //getValueFromEvent: formatCardNumber,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese el centro de costos.'
                  }
                ]
              }
            ]"
          >
            <!--
            <template
              slot="displayRender"
              slot-scope="{ labels, selectedOptions }"
            >
              <span
                v-for="(label, index) in labels"
                :key="selectedOptions[index].value"
              >
                <span v-if="index === labels.length - 1">
                  {{ label }}
                </span>
              </span>
            </template>
            -->
          </a-cascader>
          <a-tooltip
            title="El centro de costos determina el curso/actividad especifico/a. Ej: HP437"
            placement="right"
            ><a-icon
              type="question-circle-o"
              class="tooltip-icon tooltip-top"
            />
          </a-tooltip>
        </a-form-item>

        <a-form-item has-feedback v-else>
          <a-select
            placeholder="Seleccionar el centro de costos"
            @dropdownVisibleChange="loadCostCenters()"
            :notFoundContent="loadingCCs ? undefined : null"
            :disabled="costCenterDisabled"
            v-decorator="[
              'costCenterERPCode',
              {
                //getValueFromEvent: formatCardNumber,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese el centro de costos.'
                  }
                ]
              }
            ]"
          >
            <a-spin v-if="loadingCCs" slot="notFoundContent" size="small" />
            <a-select-option
              v-for="item in this.costCenters"
              :key="item.ERPCode"
              >{{ item.name }}&nbsp;<span style="color:#ccc; font-size:10px"
                >-&nbsp;{{ item.ERPCode }}</span
              ></a-select-option
            >
          </a-select>
          <a-tooltip
            title="El centro de costos determina el curso/actividad especifico/a. Ej: HP437"
            placement="right"
            ><a-icon
              type="question-circle-o"
              class="tooltip-icon tooltip-top"
            />
          </a-tooltip>
        </a-form-item>

        <a-form-item has-feedback>
          <a-select
            placeholder="Seleccionar la unidad de negocios"
            @dropdownVisibleChange="loadBusinessUnits()"
            :notFoundContent="loadingBUs ? undefined : null"
            v-decorator="[
              'businessUnitId',
              {
                //getValueFromEvent: formatCardNumber,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese la unidad de negocios.'
                  }
                ]
              }
            ]"
          >
            <a-spin v-if="loadingBUs" slot="notFoundContent" size="small" />
            <a-select-opt-group>
              <span slot="label"><a-icon type="shop" /> Sedes</span>
              <a-select-option
                v-for="item in this.businessUnits.group1"
                :key="item.id"
                >{{ item.name }}&nbsp;<span style="color:#ccc; font-size:10px"
                  >-&nbsp;{{ item.ERPCode }}</span
                ></a-select-option
              >
            </a-select-opt-group>
            <a-select-opt-group>
              <span slot="label"><a-icon type="bank" /> Oficinas</span>
              <a-select-option
                v-for="item in this.businessUnits.group2"
                :key="item.id"
                >{{ item.name }}&nbsp;<span style="color:#ccc; font-size:10px"
                  >-&nbsp;{{ item.ERPCode }}</span
                ></a-select-option
              >
            </a-select-opt-group>
            <a-select-opt-group>
              <span slot="label"><a-icon type="environment" /> Zonas</span>
              <a-select-option
                v-for="item in this.businessUnits.group3"
                :key="item.id"
                >{{ item.name }}&nbsp;<span style="color:#ccc; font-size:10px"
                  >-&nbsp;{{ item.ERPCode }}</span
                ></a-select-option
              >
            </a-select-opt-group>
            <a-select-opt-group>
              <span slot="label"><a-icon type="environment" /> Paises</span>
              <a-select-option
                v-for="item in this.businessUnits.group4"
                :key="item.id"
                >{{ item.name }}&nbsp;<span style="color:#ccc; font-size:10px"
                  >-&nbsp;{{ item.ERPCode }}</span
                ></a-select-option
              >
            </a-select-opt-group>
            <a-select-option
              v-for="item in this.businessUnits.noGroup"
              :key="item.id"
              >{{ item.name }}&nbsp;<span style="color:#ccc; font-size:10px"
                >-&nbsp;{{ item.ERPCode }}</span
              ></a-select-option
            >
          </a-select>
          <a-tooltip
            title="La unidad de negocios determina quien recibirá los ingresos del curso/actividad. Ej: Sede Uriburu"
            placement="right"
            ><a-icon
              type="question-circle-o"
              class="tooltip-icon tooltip-top"
            />
          </a-tooltip>
        </a-form-item>

        <a-form-item>
          <div :class="$style.optionTitle">
            Frecuencia de pago:
          </div>
          <a-radio-group v-decorator="['frequencyId', { initialValue: '1' }]">
            <a-radio-button value="1">Mensual</a-radio-button>
            <a-radio-button value="2">Anual</a-radio-button>
          </a-radio-group>
        </a-form-item>

        <a-form-item has-feedback>
          <div :class="$style.optionTitle">
            Días de Prueba Sin Cargo:
          </div>
          <a-input
            name="freeTrialDays"
            ref="initial"
            placeholder="Días de prueba sin cargo"
            v-decorator="[
              'freeTrialDays',
              { initialValue: this.subscription.freeTrialDays }
            ]"
          >
          </a-input>

          <a-tooltip
            title="El primer débito se realizará automaticamente al terminar el plazo de prueba. En el caso de querer bonificar el primer pago, ingresar 30 días de prueba."
            placement="right"
            ><a-icon
              type="question-circle-o"
              class="tooltip-icon tooltip-top"
            />
          </a-tooltip>
        </a-form-item>
        <!--
        <a-form-item>
          <div :class="$style.optionTitle">
            Bonificación del primer pago:
          </div>
          <a-radio-group
            v-decorator="['freeFirstPayment', { initialValue: 'false' }]"
          >
            <a-radio-button value="false">No</a-radio-button>
            <a-radio-button value="true">Si</a-radio-button>
          </a-radio-group>
          <a-tooltip
            title="En el caso de bonificar el primer pago, solo le cobrará al cliente a partir del segundo pago."
            placement="bottom"
            ><a-icon type="question-circle-o" class="tooltip-icon" />
          </a-tooltip>
        </a-form-item>
-->
        <a-form-item has-feedback>
          <div :class="$style.optionTitle">
            Finalización Automática:
          </div>
          <a-date-picker
            v-decorator="[
              'endDate',
              { initialValue: formatDate(this.subscription.endDate) }
            ]"
            :format="dateFormat"
            placeholder="Seleccione Fecha"
          />
          <a-tooltip
            title="Si selecciona una fecha, la suscripción se desactivará automáticamente en la fecha indicada."
            placement="bottom"
            ><a-icon type="question-circle-o" class="tooltip-icon" />
          </a-tooltip>
        </a-form-item>
        <!--
        <a-auto-complete
          @select="onSelect"
          @search="handleCCSearch"
          placeholder="Seleccione el codigo de curso o centro de costos"
          optionLabelProp="text"
        >
          <template slot="dataSource">
            <a-select-option
              v-for="item in costCenters"
              :key="item.id"
              :text="item.category"
            >
              {{ item.name }} \\ {{ item.product.name }}
            </a-select-option>
          </template>
          <a-input-search />
        </a-auto-complete>
        -->
        <a-form-item>
          <a-button
            v-if="isAddSubscription"
            type="primary"
            html-type="submit"
            style="padding-top:2px"
            :loading="btnLoader"
          >
            <!--<i class="icmn-user-plus" style="margin-right:0.5em" />-->Crear
            Suscripción
          </a-button>

          <a-button
            v-else
            type="primary"
            html-type="submit"
            style="vertical-align:middle"
            :loading="btnLoader"
          >
            <!--<i class="icmn-user-plus" style="margin-right:0.5em" />-->Guardar
          </a-button>
        </a-form-item>
      </a-form>

      <a
        href="javascript: void(0);"
        class="btn btn-link edit-subscription-button"
        style="margin-bottom:0"
      >
        <i class="icmn-cog mr-1" />
        Editar Suscripción
      </a>
      <!--
      <div :class="$style.controls">
        <a-button type="primary" size="large">
          <i class="icmn-user-plus" style="margin-right:0.5em" />Suscribir
          Cliente
        </a-button>
        <a href="javascript: void(0);" class="btn btn-link">
          <i class="icmn-heart mr-1" />
          Add to Wishlist
        </a>
        <a href="javascript: void(0);" class="btn btn-link">
          <i class="icmn-stats-bars mr-1" />
          Add to Compare
        </a>
      </div>
      -->
    </a-card>
  </div>
</template>

<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
import Vue from "vue";

export default {
  data() {
    return {
      loading: true,
      editIcon: false,
      subscription: {
        id: null,
        name: null,
        frequencyId: "",
        freeTrialDays: null,
        costCenter: {
          id: null,
          name: null,
          product: { name: null }
        },
        businessUnit: {
          id: null,
          name: null
        },
        product: {
          id: null,
          name: null
        }
      },
      businessUnits: {
        group1: [],
        group2: [],
        group3: [],
        group4: [],
        noGroup: []
      },
      loadingBUs: false,
      BULoaded: false,
      costCenters: [],
      loadingCCs: false,
      costCenterDisabled: true,
      products: [],
      loadingProducts: false,
      defaultProductId: null,
      amount: { validateStatus: null, errorMsg: null },
      dateFormat: "DD/MM/YYYY",
      isAddSubscription: false,
      editSubscription: false,
      form: this.$form.createForm(this),
      btnLoader: false,
      cascaderDisabled: true,
      displayCascader: false,
      cascaderOptions: [
        {
          value: "course",
          label: "Curso",
          isLeaf: false
        },
        {
          value: "event",
          label: "Evento",
          isLeaf: false
        }
      ],
      options: []
    };
  },
  props: ["subscriptionId"],
  methods: {
    ...mapActions({
      loadSubscription: "subscriptions/loadOne",
      saveSubscription: "subscriptions/save",
      addSubscription: "subscriptions/add",
      deleteSubscription: "subscriptions/delete"
    }),
    backButton() {
      if (this.$route.name == "subscriptionDetailsAdd") {
        this.$router.push(`/subscriptions`);
      } //is in edit mode
      else this.$router.push(`/subscriptions/${this.subscription.id}`);
    },
    async fetchSubscription() {
      try {
        //console.log("params:", params);
        //const id = this.$router.params.id
        this.loading = true;
        const result = await this.loadSubscription(this.$route.params.id);
        this.subscription = store.state.subscriptions.subscriptionDetails;
        this.defaultProductId = this.subscription.product.id.toString();
        await this.loadProducts(null);
        await this.loadCostCenters(null);
        await this.loadBusinessUnits(null);

        this.form.setFieldsValue({
          name: this.subscription.name,
          amount: this.subscription.amount,
          frequencyId: this.subscription.frequencyId.toString(),
          endDate: this.subscription.endDate,
          freeTrialDays: this.subscription.freeTrialDays,
          productId: this.subscription.product.id.toString(),
          costCenterERPCode: this.subscription.costCenter.ERPCode,
          businessUnitId: this.subscription.businessUnit.id.toString()
        });
        if (this.costCenters.length == 1) this.costCenterDisabled = true;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    formatDate(date) {
      if (date) {
        const d = new Date(date);
        return d.toLocaleDateString();
      } else return null;
    },
    validateAmount() {
      let value = this.$refs.amount.$children[0].currentValue;
      if (value === undefined || value == "$ ") {
        this.amount = {
          validateStatus: "error",
          errorMsg: "Por favor, ingresar el precio."
        };
      } else {
        value = value.slice(2, value.length + 1); //remove '$ '
        value = value.replace(/,/g, ""); //removes all occurrences of ","
        if (isNaN(value))
          this.amount = {
            validateStatus: "error",
            errorMsg: "Solo se aceptan números."
          };
        else
          this.amount = {
            validateStatus: "success",
            errorMsg: null
          };
      }
    },
    async handleSubmit(e) {
      try {
        let subscription, subscriptionId;
        e.preventDefault();
        this.btnLoader = true;
        this.validateAmount();
        this.form.validateFields(async (err, values) => {
          try {
            if (!err) {
              console.log("Received values of form: ", values);
              //seleccionó un centro de costos de harmony
              if (values.costCenterERPCode === undefined) {
                values.costCenterERPCode = values.costCenter[1];
              }
              subscription = values;

              if (this.isAddSubscription) {
                subscriptionId = await this.addSubscription(subscription);
                this.$store.commit("subscriptions/SET_LIST_UPDATED", true);
                this.$router.push(`/subscriptions/${subscriptionId}`);
              } else {
                //is update
                subscription.id = this.subscription.id;
                await this.saveSubscription(subscription);
                this.subscription =
                  store.state.subscriptions.subscriptionDetails;
                this.$router.push(`/subscriptions/${this.subscription.id}`);
              }
            } else throw new Error("Error de validación.");
          } catch (err) {
            //el catch esta duplicado porque dentro de validateFields no bubblea al parent catch
            const x = 10;
            this.btnLoader = false;
            let message = err.message
              ? err.message
              : "Hubo un error al guardar la suscripción";
            let code = err.code ? err.code : "Error";

            this.$notification["warning"]({
              message: code,
              description: message
            });
          }
        });

        this.btnLoader = false;
      } catch (error) {
        console.log(error);
        this.btnLoader = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    handleEditSubscription() {
      this.editSubscription = true;

      //alert("hola");
    },
    async loadBusinessUnits(value) {
      if (!this.BULoaded) {
        this.loadingBUs = true;
        try {
          const res = await Vue.prototype.$axios.get(
            `/admin/business-units?pageSize=100&orderBy=name`
          );
          if (res.data) {
            const options = {
              group1: [],
              group2: [],
              group3: [],
              group4: [],
              noGroup: []
            };
            res.data.results.forEach(item => {
              let option = {
                id: item.id.toString(),
                name: item.name,
                ERPCode: item.ERPCode
              };
              if (item.groupName.toLowerCase() == "sedes")
                options.group1.push(option);
              else if (item.groupName.toLowerCase() == "oficinas")
                options.group2.push(option);
              else if (item.groupName.toLowerCase() == "zonas")
                options.group3.push(option);
              else if (item.groupName.toLowerCase() == "paises")
                options.group4.push(option);
              else options.noGroup.push(option);
            });
            this.businessUnits = options;
            this.loadingBUs = false;
            this.BULoaded = true;
          }
        } catch (error) {
          this.loadingBUs = false;
          console.log(error);
          throw error;
        }
      }
    },
    async loadCostCenters(value) {
      //if (this.costCenters.length == 0) {
      this.loadingCCs = true;
      this.costCenters = [];
      this.costCenterDisabled = false;
      this.form.setFieldsValue({
        costCenterERPCode: null
      });
      this.form.resetFields({ names: "costCenterERPCode" });
      try {
        const res = await Vue.prototype.$axios.get(
          `/admin/cost-centers?pageSize=1000&defaultProductId=${this.defaultProductId}`
        );
        if (res.data) {
          const options = new Array();
          res.data.results.forEach(item => {
            options.push({
              id: item.id.toString(),
              name: item.name,
              ERPCode: item.ERPCode
            });
          });
          this.costCenters = options;
          this.loadingCCs = false;
        }
      } catch (error) {
        this.loadingCCs = false;
        console.log(error);
        throw error;
      }
      //}
    },
    async handleProductChange(val) {
      this.defaultProductId = val;
      let harmonyCode = this.products.find(product => product.id == val)
        .harmonyCode;

      if (harmonyCode === null) {
        this.displayCascader = false;
        await this.loadCostCenters(null);
        //si solo hay un resultado, seleccionarlo automaticamente
        if (this.costCenters.length == 1) {
          this.form.setFieldsValue({
            costCenterERPCode: this.costCenters[0].ERPCode
          });
          this.costCenterDisabled = true;
        }
      } else {
        this.displayCascader = true;
        this.cascaderDisabled = false;
      }
    },
    async loadProducts(value) {
      if (this.products.length == 0) {
        this.loadingProducts = true;
        try {
          const res = await Vue.prototype.$axios.get(
            `/admin/products?pageSize=100&subscriptionFilter=true`
          );
          if (res.data) {
            const options = new Array();
            res.data.results.forEach(item => {
              options.push({
                id: item.id.toString(),
                name: item.name,
                ERPCode: item.ERPCode,
                defaultProductId: item.defaultProductId,
                harmonyCode: item.harmonyCode
              });
            });
            this.products = options;
            this.loadingProducts = false;
          }
        } catch (error) {
          this.loadingProducts = false;
          console.log(error);
          throw error;
        }
      }
    },
    async loadCascaderData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      let res, offset, limit, totalPages, options, tempOptions;
      try {
        if (targetOption.value == "tupaggo") {
          res = await Vue.prototype.$axios.get(
            `/admin/cost-centers?defaultProductId=${this.defaultProductId}`
          );
          if (res.data) {
            options = new Array();
            res.data.results.forEach(item => {
              options.push({
                label: item.name,
                value: item.ERPCode,
                defaultProductId: item.defaultProductId
              });
            });
          }
        } else if (targetOption.value == "course") {
          offset = 1; //en harmony offset es el page
          limit = 100;
          totalPages = 1;
          tempOptions = new Array();

          Vue.prototype.$axiosHarmony.defaults.headers.common["Authorization"] =
            process.env.VUE_APP_HARMONY_COURSES_SEARCH_API_KEY;

          this.orderByOptions.find(opt => {
            return opt.key == event.key;
          });

          let harmonyProductCode = this.products.find(
            product => product.id == this.defaultProductId
          ).harmonyCode;

          for (offset = 1; offset <= totalPages; offset++) {
            res = await Vue.prototype.$axiosHarmony.get(`/courses`, {
              params: {
                type: "country",
                country: "ar",
                language: "es-ar",
                mctype: harmonyProductCode,
                limit,
                offset
              }
            });
            if (res.data) {
              res.data.courses.forEach(item => {
                if (!tempOptions[item.title])
                  tempOptions[item.title] = new Array();
                if (item.course_id.trim() != "") {
                  tempOptions[item.title].push({
                    label: `${item.title} - ${item.course_id}`,
                    value: item.course_id
                  });
                }
              });
              totalPages = Math.ceil(res.data.total / limit);
            }
          }
          options = new Array();
          for (var key in tempOptions) {
            tempOptions[key].sort((a, b) => {
              if (a.value < b.value) {
                return -1;
              } else return 1;
            });
            options = options.concat(tempOptions[key]);
          }
        } else if (targetOption.value == "event") {
          offset = 1;
          limit = 100;
          totalPages = 1;
          tempOptions = new Array();

          Vue.prototype.$axiosHarmony.defaults.headers.common["Authorization"] =
            process.env.VUE_APP_HARMONY_EVENTS_SEARCH_API_KEY;

          for (offset = 1; offset <= totalPages; offset++) {
            res = await Vue.prototype.$axiosHarmony.get(`/events`, {
              params: {
                type: "country",
                country: "ar",
                limit,
                offset
              }
            });
            if (res.data) {
              res.data.courses.forEach(item => {
                if (item.course_id.trim() != "") {
                  if (!tempOptions[item.title])
                    tempOptions[item.title] = new Array();
                  tempOptions[item.title].push({
                    label: `${item.title} - ${item.course_id}`,
                    value: item.course_id
                  });
                }
              });
              totalPages = Math.ceil(res.data.total / limit);
            }
          }
          options = new Array();
          for (var key2 in tempOptions) {
            tempOptions[key2].sort((a, b) => {
              if (a.value < b.value) {
                return -1;
              } else return 1;
            });
            options = options.concat(tempOptions[key2]);
          }
        }
        targetOption.children = options;
        this.cascaderOptions = [...this.cascaderOptions];
        targetOption.loading = false;
      } catch (error) {
        targetOption.loading = false;
        console.log(error);
        throw error;
      }
    },
    handleRoute() {
      if (this.$route.name == "subscriptionDetailsAdd") {
        this.isAddSubscription = true;
      } else if (this.$route.name == "subscriptionDetailsEdit") {
        this.editSubscription = true;
        this.fetchSubscription();
      }
    }
  },
  mounted() {
    this.handleRoute();
  },
  watch: {
    //REACTIVE TO URL CHANGE
    $route(to) {
      this.handleRoute();
    }
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
</style>

<style lang="css">
.ant-card {
  border-radius: 7px;
}
.ant-card-head-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 2rem;
}
.ant-card-body {
  padding-bottom: 9px;
}
.ant-form-item-control-wrapper {
  /*white-space: nowrap;*/
}
.back-button {
  /*background-color: #fff;
  border-color: #777;
  color: #777;*/
  vertical-align: 0.38rem;
}
.back-button .anticon {
  vertical-align: -0.213rem;
}
.ant-collapse-item {
  border-bottom: none !important;
}
.add-form {
  width: 30rem;
}
.tooltip-icon {
  color: #ccc;
  margin-left: 0.5rem;
}
.tooltip-top {
  position: absolute;
  top: 2px;
  right: -19px;
}
@media (max-width: 767px) {
  .ant-card-head-wrapper {
    flex-direction: column-reverse !important;
    align-items: flex-start;
  }
  .ant-card-head-title {
    flex-grow: 5;
    /*font-size: 100%;*/
    width: 25rem;
  }
  .ant-card-extra {
    float: inherit !important;
    margin-left: inherit !important;
    align-self: flex-end;
  }
  .add-form {
    width: inherit;
  }
  .ant-switch {
    margin-left: 0 !important;
  }
  .title-id {
    display: none;
  }
  .hover-title {
    font-size: 1.7rem;
    letter-spacing: -1px;
  }
  .hover-title + .edit-icon {
    display: inline;
  }
  .edit-subscription-button {
    display: inline !important;
  }
}
.edit-subscription-button {
  display: none;
}
.edit-icon {
  display: none;
}
.hover-title {
  cursor: pointer;
}
.hover-title:hover + .edit-icon {
  display: inline;
}
</style>
